export default __webpack_public_path__ + "static/media/mg-img.ce373901.png";